import {styled } from '@mui/material/styles';

const LoginContainer = styled('div')({
    minHeight:'100vh',
    overflowY: 'auto',
    // marginTop: "0.2px",
    // marginBottom:'0.2px',
     marginRight:'20px',
    // padding: "10px",
    background: '#F8FCFF',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  })
  
  const Image = styled('div')({
   '@media (max-width: 992px)': {
       display: 'none', 
       alignItems:'center',
     },
  })
  
  const LogoBox = styled('div')({
    display:'flex',
    flexDirection:'row',
    alignItems:'center',
    justifyContent:'center',
    margin:'15px 0px 20px 0px',
    '@media (max-width: 768px)': {
      margin:'15px 20px', 
    },
  })
  
  const LoginDetails =styled('div')({
    background: '#FFFFFF',
    width: 'auto',
    height: '280px',
    borderRadius:'10px',
    padding: "20px 20px 32px",
    margin:'30px 50px',
    '@media (max-width: 768px)': {
      margin:'30px 20px', 
      alignItems:'center',
      fontSize:'18px',
    },
  })

  const ForgotPasswordDetails =styled('div')({
    background: '#FFFFFF',
    width: 'auto',
    height: '260px',
    borderRadius:'10px',
    padding: "20px 20px 32px",
    margin:'40px 50px',
    '@media (max-width: 992px)': {
      margin:'40px 20px', 
      alignItems:'center',
    },
  })

  const ResetPasswordDetails =styled('div')({
    background: '#FFFFFF',
    width: 'auto',
    height: '400px',
    borderRadius:'10px',
    padding: "20px 20px 32px",
    margin:'40px 50px',
    '@media (max-width: 992px)': {
      margin:'40px 20px', 
      alignItems:'center',
    },
  })
  
  const ParentContainer = styled('div')({
    margin:'10px 50px',
    alignSelf: 'stretch',
    borderRadius: '15px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 4px 4px rgba(0, 0, 0, 0.25)',
    border: '1px solid rgba(0, 0, 0, 0.5)',
    boxSizing: 'border-box',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '10px 45px 20px 43px',
    gap: '34px',
    maxWidth: '100%',
    textAlign: 'left',
    fontSize: '16px,',
    color: '#2194f3',
  })

  const SignIn4Inner = styled('div')({
    width: '80%',
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    padding: "10px 10px",
    boxSizing: "border-box",
    height:'100vh',
  })

  export {ParentContainer, SignIn4Inner, LoginContainer, LogoBox, LoginDetails, ForgotPasswordDetails, ResetPasswordDetails}